<style scoped>

  .search-button {
    width: 120px;
  }

</style>

<template>

  <div :id="_uid" class="ui large modal address-picker-modal">

    <div class="ui header">
      Pesquisar Endereço
    </div>

    <div class="content modal-content-scrolling">

      <form class="ui form" @submit.prevent="onSearch()">
        <div class="fields">
          <div class="sixteen wide field">
            <div class="ui action input">
              <input type="text" placeholder="CEP ou Endereço" v-model="keyWord">
              <button type="button" class="ui basic button search-button" :class="{ loading }" @click="onSearch()">
                <i v-if="!loading" class="search blue icon"></i> Pesquisar
              </button>
            </div>
          </div>
        </div>        
      </form>

      <div v-if="adresses && adresses.length == 0" class="ui small label m-t-15 animated fadeIn">
        <i class="info circle icon"></i> Nenhum endereço encontrado
      </div>

      <div v-if="adresses && adresses.length > 0" class="ui segment animated fadeIn" :class="{ loading }">        
        <table class="ui very basic celled selectable tablet stackable table">          
          <tbody>
            <tr v-for="(address, index) in adresses" :key="index" class="clickable" @click="onSelectAddress(address)">              
              <td>
                {{ address.label }}
              </td>                            
            </tr>            
          </tbody>
        </table>
      </div>

    </div>

    <div class="actions">
      <button class="ui basic button" @click="hide()">
        <i class="reply icon"></i>
        Cancelar
      </button>      
    </div>

  </div>

</template>

<script>

  import ZipCodeService from "@/services/zip-code-service"
  import Message from "@/utils/message"
  
  export default {

    data() {
      return {
        loading: false,
        keyWord: "",
        adresses: null,
      }
    },

    props: ["allowMultiple"],    

    mounted() {

      $("#" + this._uid).modal({ allowMultiple: this.allowMultiple })
    },
    
    beforeDestroy() {
      $(".address-picker-modal").remove()
    },

    methods: {

      show() {
        this.setVisibile(true)
      },

      hide() {
        this.setVisibile(false)        
      },

      setVisibile(visbible) {

        this.loading = false
        this.keyWord = ""
        this.adresses = null

        const action = visbible ? "show" : "hide"

        $("#" + this._uid).modal(action)
      },

      async onSearch() {

        if (this.loading)
          return

        if (this.keyWord.trim().length < 4) {
          Message.info("Informe ao menos 4 caracteres para pesquisa")
          return
        }

        this.loading = true

        const keyWord = this.keyWord

        try {

          this.adresses = await ZipCodeService.search(keyWord)          
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      onSelectAddress(address) {  

        this.hide()
        this.$emit("onSelect", address)
      },
    },
  }

</script>
